<template>
    <div :class="{ 'loading-dots': true }">
        <div />
        <div />
        <div />
    </div>
</template>

<script>
export default {
    props: {
        className: {
            type: String,
            default: '',
        },
    },
};
</script>

<style lang="scss">
$dot-background: #6c3e91;
$dot-color: #4f2571;
/*
  Animations
  ------------------------------------------------------
*/

@keyframes refreshingSpinnerA {
    0% {
        transform: translate(-50%, -50%) scale(1.75);
        background-color: $dot-background;
    }
    33% {
        transform: translate(-50%, -50%) scale(1, 1);
    }
    66% {
        transform: translate(-50%, -50%) scale(1, 1);
    }
    100% {
        transform: translate(-50%, -50%) scale(1, 1);
    }
}

@keyframes refreshingSpinnerB {
    0% {
        transform: translate(-50%, -50%) scale(1, 1);
    }
    33% {
        transform: translate(-50%, -50%) scale(1.75);
        background-color: $dot-background;
    }
    66% {
        transform: translate(-50%, -50%) scale(1, 1);
    }
    100% {
        transform: translate(-50%, -50%) scale(1, 1);
    }
}

@keyframes refreshingSpinnerC {
    0% {
        transform: translate(-50%, -50%) scale(1, 1);
    }
    33% {
        transform: translate(-50%, -50%) scale(1, 1);
    }
    66% {
        transform: translate(-50%, -50%) scale(1.75);
        background-color: $dot-background;
    }
    100% {
        transform: translate(-50%, -50%) scale(1, 1);
    }
}

/*
    Loading Dots
    ----------------------------------------------
*/
.loading-dots {
    /*position: absolute;*/
    transform: translate(0, 0);
    transform: translateX(50%);
    width: 16px;
    height: 18px;
    /*right: 50%;*/
    margin-top: 18px;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 18px;

    div {
        width: 4px;
        height: 4px;
        background-color: $dot-color;
        border-radius: 50%;
        position: absolute;
        top: 50%;
        transform: translate(-50%, -50%);
    }

    div:nth-child(1) {
        left: 0;
        animation: refreshingSpinnerA 0.8s cubic-bezier(0.645, 0.045, 0.355, 1) infinite;
    }
    div:nth-child(2) {
        left: 50%;
        animation: refreshingSpinnerB 0.8s cubic-bezier(0.645, 0.045, 0.355, 1) infinite;
    }
    div:nth-child(3) {
        left: 100%;
        animation: refreshingSpinnerC 0.8s cubic-bezier(0.645, 0.045, 0.355, 1) infinite;
    }
}
</style>
